export default "__VITE_ASSET__BmO_B88g__"